export const RIGHT_SIDEBAR_WIDTH = 384;
